import { render, staticRenderFns } from "./WebRTC.vue?vue&type=template&id=67da2c2a&scoped=true&"
import script from "./WebRTC.vue?vue&type=script&lang=js&"
export * from "./WebRTC.vue?vue&type=script&lang=js&"
import style0 from "./WebRTC.vue?vue&type=style&index=0&id=67da2c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67da2c2a",
  null
  
)

export default component.exports